var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleTagManager = function SvgGoogleTagManager(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8AB4F8",
    d: "m14.088 23.017-4.166-4.062 8.947-9.137 4.313 4.228z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M14.105 5.056 9.954.818.878 9.808a2.997 2.997 0 0 0 0 4.239l8.94 8.998 4.227-3.954-6.811-7.163z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8AB4F8",
    d: "m23.121 9.878-9-9a3 3 0 0 0-4.242 4.243l9 9a3 3 0 0 0 4.242-4.243"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#246FDB",
    d: "M11.932 24a2.932 2.932 0 1 0 0-5.863 2.932 2.932 0 0 0 0 5.863"
  })));
};
export default SvgGoogleTagManager;